export interface BaseMarker {
	tag_id?: number;
	tag_set_id?: number;
	tag_name: string;
	tag_color: string;
	sort_index?: number;
	created_by?: number;
	tag_abbreviation?: string;
	tag_preset_comment?: string;
	category?: TagCategory;
}

export interface Marker extends BaseMarker {
	created_at: string;
	deleted_at: string|null;
	deleted_by: number|null;
	updated_at?: string;
	updated_by?: number;
	was_ai_generated?: boolean;
	count?: number;
	is_ai_marker?: boolean;
	instance?: number;
}

export enum TagCategoryName {
	PRAISE = 'Praise',
	IMPROVE = 'Improve',
	GENERAL = 'General'
}

export interface TagCategory {
	id: number;
	name: string;
	short_name: TagCategoryName;
	color: string;
	icon: string;
	is_ai: boolean;
}

export interface MarkerSet {
	id?: number;
	title?: string;
	description?: string;
	tags: Marker[];
	created_at?: string;
	owner_id?: number;
}

export interface CreateMarkerSetPayload extends MarkerSet {
	add_to_collection: number;
	add_to_folder: number|null;
}
